import { render, staticRenderFns } from "./MKoreanPriceSpecial.vue?vue&type=template&id=7539c7c1&scoped=true"
import script from "./MKoreanPriceSpecial.vue?vue&type=script&lang=js"
export * from "./MKoreanPriceSpecial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7539c7c1",
  null
  
)

export default component.exports